module.exports = __webpack_public_path__ + "media/yates.c758f221.mp3";